import React from 'react';
import styled from 'styled-components';

import { T } from 'containers';
import { Box } from 'rebass';
import { AppText } from 'domain/appText';

import { GlowHeading } from 'components';

const StyledBox = styled(Box)`
  background-color: #fff;
  color: #294666;
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  padding: 0px;
  font-size: 14px;
  text-align: left;

  .inner{
    background-color: #e1f0e7;
    padding: 40px;
    border: 1px solid #b8d9c6;

    h1{
      color: #4d8062;
      font-size: 24px;
      line-height: 1.2em;
      display: inline-block;
      vertical-align: middle;
      width: calc(100% - 55px);
    }
  }

  img{
    width: 40px;
    height: auto;
    display: inline-block;
    vertical-align: middle;
    margin-right: 10px;
  }
`;

const SelectCabinAllDone = () => (
  <T
    text={[
      AppText.CabinDistributionDone,
    ]}
    render={([
      cabinDistributionDone,
    ]) => (
      <StyledBox>
        <div className="inner">
          <img src="/assets/images/ok.svg" alt="OK" />
          <GlowHeading f={3}>{cabinDistributionDone}</GlowHeading>
        </div>
      </StyledBox>
    )}
  />
);
export default SelectCabinAllDone;



// WEBPACK FOOTER //
// ./src/components/organisms/SelectCabinAllDone/index.js